/**
 * Modal de pago: métodos, resumen, vuelto y sincronización con carrito.
 */

function initPaymentModalEvents(win, $) {
	if (win._posknPaymentModalBound) return;
	win._posknPaymentModalBound = true;

	$(document).on('click', '.payment-amount-input input', (e) => {
		e.stopPropagation();
	});

	$(document).on('click', '.payment-method', function onClickPaymentMethod() {
		const $metodo = $(this);
		const checkbox = $metodo.find('.payment-checkbox');
		checkbox.prop('checked', !checkbox.is(':checked'));

		if (checkbox.is(':checked')) {
			$metodo.addClass('selected');
			const $input = $metodo.find('.payment-amount-input input.payment-amount-field, .payment-amount-input input[type="number"]');
			if (!$input.val()) {
				win.autoRellenarMetodoPago($metodo);
			}
			$input.focus();
		} else {
			$metodo.removeClass('selected');
			$metodo.find('.payment-amount-input input.payment-amount-field, .payment-amount-input input[type="number"]').val('');
			$metodo.find('.payment-ref-input').val('');
		}

		win.actualizarResumenPago();
	});

	$(document).on('change', '#vuelto-ajuste-activo', function onChangeVueltoAjuste() {
		const checked = $(this).prop('checked');
		$('#vuelto-ajuste-opciones').toggle(checked);
		if (checked) {
			win.rellenarVueltoRestarMetodo();
			win.rellenarVueltoSumarMetodo();
		}
	});

	$(document).on('change', 'input[name="vuelto-moneda"]', () => {
		win.rellenarVueltoRestarMetodo();
		win.rellenarVueltoSumarMetodo();
	});

	$(document).on('input', '.payment-amount-input input', () => {
		win.actualizarResumenPago();
	});

	if (document && typeof document.addEventListener === 'function') {
		document.addEventListener(
			'wheel',
			(e) => {
				const t = e.target;
				if (!t || !t.closest || !t.closest('#modal-pago')) return;
				if (!t.matches || !t.matches('.payment-amount-field, .payment-amount-input input')) return;
				t.blur();
			},
			{ passive: true },
		);
	}
}

export function attachPaymentModalGlobals(win, $) {
	initPaymentModalEvents(win, $);

	win.sincronizarTotalesModalPagoDesdeCarrito = function sincronizarTotalesModalPagoDesdeCarrito() {
		const tot =
			typeof win.posknTotalesDesdeCarrito === 'function'
				? win.posknTotalesDesdeCarrito()
				: {
						totalUsd: parseFloat($('#total-usd').text().replace('$', '')) || 0,
						totalBs: parseFloat($('#total-bs').text().replace('Bs. ', '')) || 0,
					};
		$('#pago-total-usd').text(`$${Number(tot.totalUsd).toFixed(2)}`);
		$('#pago-total-bs').text(`Bs. ${Number(tot.totalBs).toFixed(2)}`);
	};

	win.abrirModalPago = function abrirModalPago() {
		const carrito = win.carrito || [];
		if (!carrito.length) {
			win.mostrarNotificacion('El carrito está vacío', 'error');
			return;
		}

		win.sincronizarTotalesModalPagoDesdeCarrito();

		$('.payment-method').removeClass('selected');
		$('.payment-checkbox').prop('checked', false);
		$('.payment-amount-input input').val('');
		$('#payment-summary-detail').hide();
		$('#btn-crear-pedido').prop('disabled', true);
		$('#credito-requiere-cliente-aviso').hide();

		$('#modal-pago').css('display', 'flex');
	};

	win.rellenarMetodosPorMonedaVuelto = function rellenarMetodosPorMonedaVuelto($select, soloConMonto) {
		const $modal = $('#modal-pago');
		const monedaVuelto = ($modal.find('input[name="vuelto-moneda"]:checked').val() || 'USD').toUpperCase();
		$select.empty().append('<option value="">Seleccionar método</option>');
		const $base = $modal.find('.payment-method');
		const $metodos = soloConMonto ? $modal.find('.payment-method.selected') : $base;

		$metodos.each(function eachMetodoVuelto() {
			const $el = $(this);
			const metodo = ($el.attr('data-method') || $el.data('method') || '').toString();
			if (!metodo || metodo === 'credito') return;

			if (soloConMonto) {
				const monto = parseFloat($el.find('.payment-amount-input input.payment-amount-field, .payment-amount-input input[type="number"]').val()) || 0;
				if (monto <= 0) return;
			}

			const currency = ($el.attr('data-currency') || $el.data('currency') || 'USD').toString().toUpperCase();
			const esBs = currency === 'BS';
			if ((esBs && monedaVuelto !== 'BS') || (!esBs && monedaVuelto !== 'USD')) return;

			const prefijo = esBs ? 'Bs - ' : 'USD - ';
			const nombre = $el.find('.payment-method-header div').first().text().trim() || metodo;
			const valor = `${esBs ? 'BS|' : 'USD|'}${metodo}`;
			$select.append($('<option></option>').attr('value', valor).text(prefijo + nombre));
		});
	};

	win.rellenarVueltoRestarMetodo = function rellenarVueltoRestarMetodo() {
		win.rellenarMetodosPorMonedaVuelto($('#vuelto-restar-metodo'), false);
	};

	win.rellenarVueltoSumarMetodo = function rellenarVueltoSumarMetodo() {
		win.rellenarMetodosPorMonedaVuelto($('#vuelto-sumar-metodo'), false);
	};

	win.autoRellenarMetodoPago = function autoRellenarMetodoPago($metodoElement) {
		if (!$metodoElement || !$metodoElement.length) return;

		const metodo = ($metodoElement.attr('data-method') || $metodoElement.data('method') || '').toString();
		const $input = $metodoElement.find('.payment-amount-input input.payment-amount-field, .payment-amount-input input[type="number"]');
		if (!$input.length) return;

		if (metodo === 'credito') return;

		const currency = ($metodoElement.attr('data-currency') || $metodoElement.data('currency') || '').toString().toUpperCase();
		if (!currency) return;

		const totAuto =
			typeof win.posknTotalesDesdeCarrito === 'function' ? win.posknTotalesDesdeCarrito() : null;
		const totalUsd = totAuto ? totAuto.totalUsd : parseFloat($('#pago-total-usd').text().replace('$', '')) || 0;
		const totalBs = totAuto ? totAuto.totalBs : parseFloat($('#pago-total-bs').text().replace('Bs. ', '')) || 0;
		if (!totalUsd && !totalBs) return;

		let pagadoUsd = 0;
		let pagadoBs = 0;
		const tasa = win.TASA_DOLAR || 1;
		const parseMonto =
			typeof win.posknParseMontoInput === 'function'
				? win.posknParseMontoInput
				: (raw) => parseFloat(String(raw || '').replace(',', '.')) || 0;

		$('.payment-method.selected').each(function eachSelectedMethod() {
			const $el = $(this);
			if ($el.is($metodoElement)) return;

			const metodoEl = ($el.attr('data-method') || $el.data('method') || '').toString();
			const monto = parseMonto(
				$el.find('.payment-amount-input input.payment-amount-field, .payment-amount-input input[type="number"]').val(),
			);
			if (!monto) return;

			if (metodoEl === 'credito') {
				pagadoUsd += monto;
				return;
			}

			const currEl = ($el.attr('data-currency') || $el.data('currency') || 'USD').toString().toUpperCase();
			if (currEl === 'BS') pagadoBs += monto;
			else pagadoUsd += monto;
		});

		const cobro =
			typeof win.posknResumenCobro === 'function'
				? win.posknResumenCobro(pagadoUsd, pagadoBs, totalUsd, totalBs, tasa)
				: null;
		const fromC =
			typeof win.moneyFromCents === 'function' ? win.moneyFromCents : (c) => (Number(c) || 0) / 100;

		if (currency === 'BS') {
			const restC = cobro ? cobro.totBsC - cobro.pagadoBsEquivC : Math.round((totalBs - pagadoBs - pagadoUsd * tasa) * 100);
			if (restC > 1) $input.val(fromC(restC).toFixed(2));
		} else {
			const restC = cobro ? cobro.totUsdC - cobro.pagadoUsdEquivC : Math.round((totalUsd - pagadoUsd - pagadoBs / tasa) * 100);
			if (restC > 1) $input.val(fromC(restC).toFixed(2));
		}
	};

	win.actualizarResumenPago = function actualizarResumenPago() {
		const metodos = [];
		let pagadoUsd = 0;
		let pagadoBs = 0;
		let tieneCredito = false;
		const tasa = win.TASA_DOLAR || 1;

		$('.payment-method.selected').each(function eachSelectedPayment() {
			const $row = $(this);
			const metodo = ($row.attr('data-method') || $row.data('method') || '').toString();
			const raw = $row.find('.payment-amount-input input.payment-amount-field, .payment-amount-input input[type="number"]').val();
			const monto =
				typeof win.posknParseMontoInput === 'function'
					? win.posknParseMontoInput(raw)
					: parseFloat(String(raw || '').replace(',', '.')) || 0;

			if (metodo === 'credito') {
				tieneCredito = true;
				if (monto > 0) {
					metodos.push({ metodo, monto });
					pagadoUsd += monto;
				} else {
					metodos.push({ metodo, monto: 0 });
				}
			} else if (monto > 0) {
				metodos.push({ metodo, monto });
				const currency = ($row.attr('data-currency') || $row.data('currency') || 'USD').toString().toUpperCase();
				if (currency === 'BS') {
					pagadoBs += monto;
				} else {
					pagadoUsd += monto;
				}
			}
		});

		if (!metodos.length) {
			$('#payment-summary-detail').hide();
			$('#btn-crear-pedido').prop('disabled', true);
			$('#credito-requiere-cliente-aviso').hide();
			return;
		}

		const totRes =
			typeof win.posknTotalesDesdeCarrito === 'function' ? win.posknTotalesDesdeCarrito() : null;
		const totalUsd = totRes ? totRes.totalUsd : parseFloat($('#pago-total-usd').text().replace('$', '')) || 0;
		const totalBs = totRes ? totRes.totalBs : parseFloat($('#pago-total-bs').text().replace('Bs. ', '')) || 0;

		const cobro =
			typeof win.posknResumenCobro === 'function'
				? win.posknResumenCobro(pagadoUsd, pagadoBs, totalUsd, totalBs, tasa)
				: null;
		const restanteUsd = cobro ? cobro.restanteUsd : totalUsd - (pagadoUsd + pagadoBs / tasa);
		const restanteBs = cobro ? cobro.restanteBs : totalBs - (pagadoBs + pagadoUsd * tasa);
		const esVueltoUsd = cobro ? cobro.vueltoUsd : restanteUsd < -0.01;
		const esVueltoBs = cobro ? cobro.vueltoBs : restanteBs < -0.01;

		$('#pagado-usd').text(`$${(cobro ? cobro.pagadoUsd : pagadoUsd).toFixed(2)}`);
		$('#pagado-bs').text(`Bs. ${(cobro ? cobro.pagadoBs : pagadoBs).toFixed(2)}`);

		if (tieneCredito) {
			const rUsd = Math.max(0, restanteUsd);
			const rBs = Math.max(0, restanteBs);
			$('#restante-usd-label').html('<strong>Saldo pendiente USD:</strong>');
			$('#restante-bs-label').html('<strong>Saldo pendiente Bs:</strong>');
			$('#restante-usd').html(`<strong style="color: #FF9800;">$${rUsd.toFixed(2)}</strong>`);
			$('#restante-bs').html(`<strong style="color: #FF9800;">Bs. ${rBs.toFixed(2)}</strong>`);
		} else {
			if (esVueltoUsd) {
				$('#restante-usd-label').html('<strong>Vuelto USD:</strong>');
				$('#restante-usd').text(`-$${Math.abs(restanteUsd).toFixed(2)}`).css('color', '#2e7d32');
			} else {
				$('#restante-usd-label').html('<strong>Restante USD:</strong>');
				$('#restante-usd').text(`$${Number(restanteUsd).toFixed(2)}`).css('color', restanteUsd > 0.005 ? '#d32f2f' : '#2e7d32');
			}
			if (esVueltoBs) {
				$('#restante-bs-label').html('<strong>Vuelto Bs:</strong>');
				$('#restante-bs').text(`-Bs. ${Math.abs(restanteBs).toFixed(2)}`).css('color', '#2e7d32');
			} else {
				$('#restante-bs-label').html('<strong>Restante Bs:</strong>');
				$('#restante-bs').text(`Bs. ${Number(restanteBs).toFixed(2)}`).css('color', restanteBs > 0.005 ? '#d32f2f' : '#2e7d32');
			}
		}

		if (tieneCredito) {
			const credUsd = Math.max(0, restanteUsd);
			const credBs = credUsd * tasa;
			$('#credito-equiv-bs').text(
				`Crédito: $${credUsd.toFixed(2)}  ·  Bs. ${credBs.toFixed(2)}  (tasa ${Number(tasa).toFixed(2)})`
			);
		} else {
			$('#credito-equiv-bs').text('Se registra en USD. El equivalente en Bs usa la tasa del POS.');
		}

		const hayVueltoUsd = esVueltoUsd;
		const hayVueltoBs = esVueltoBs;
		const hayVuelto = hayVueltoUsd || hayVueltoBs;
		win._ultimoRestanteUsd = restanteUsd;
		win._ultimoRestanteBs = restanteBs;
		const vueltoUsdVal = Math.abs(restanteUsd);
		const vueltoBsVal = Math.abs(restanteBs);

		if (hayVuelto) {
			$('#vuelto-ajuste-container').show();
			$('#vuelto-ajuste-activo').prop('checked', false);
			$('#vuelto-ajuste-opciones').hide();
			$('#vuelto-opcion-usd-text').text(`USD: $${vueltoUsdVal.toFixed(2)}`);
			$('#vuelto-opcion-bs-text').text(`Bs: Bs. ${vueltoBsVal.toFixed(2)}`);

			if (hayVueltoUsd && !hayVueltoBs) {
				$('input[name="vuelto-moneda"][value="USD"]').prop('checked', true);
				$('input[name="vuelto-moneda"][value="BS"]').prop('disabled', true);
			} else if (hayVueltoBs && !hayVueltoUsd) {
				$('input[name="vuelto-moneda"][value="BS"]').prop('checked', true);
				$('input[name="vuelto-moneda"][value="USD"]').prop('disabled', true);
			} else {
				$('input[name="vuelto-moneda"][value="USD"]').prop('disabled', false);
				$('input[name="vuelto-moneda"][value="BS"]').prop('disabled', false);
				if (!$('input[name="vuelto-moneda"]:checked').length) {
					$('input[name="vuelto-moneda"][value="USD"]').prop('checked', true);
				}
			}

			win.rellenarVueltoRestarMetodo();
			win.rellenarVueltoSumarMetodo();
		} else {
			$('#vuelto-ajuste-container').hide();
			$('#vuelto-ajuste-activo').prop('checked', false);
			$('#vuelto-ajuste-opciones').hide();
		}

		$('#payment-summary-detail').show();

		const totalCubierto = cobro ? cobro.covered : restanteUsd <= 0.01 || restanteBs <= 0.01;
		const requiereClienteCredito = tieneCredito && !win.clienteSeleccionado;
		const puedeCrearPedido = (totalCubierto || tieneCredito) && !requiereClienteCredito;
		$('#btn-crear-pedido').prop('disabled', !puedeCrearPedido);

		if (requiereClienteCredito) {
			$('#credito-requiere-cliente-aviso').show();
		} else {
			$('#credito-requiere-cliente-aviso').hide();
		}
	};
}
